var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.allItems,"menu-props":_vm.menuProps,"item-text":"text","item-value":"value","label":"Attendants","dense":"","hide-details":"","outlined":"","multiple":""},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})
}
var staticRenderFns = []

export { render, staticRenderFns }